import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RoomView } from './pages/RoomView';
import { PDFViewer } from './pages/PDFViewer';
import { Login } from './pages/admin/Login';
import { Dashboard } from './pages/admin/Dashboard';
import { ProjectDetail } from './pages/admin/ProjectDetail';
import { RoomDetail } from './pages/admin/RoomDetail';
import { BulkQRCodes } from './pages/admin/BulkQRCodes';
import { TaskManagement } from './pages/admin/TaskManagement';
import { NotesModeration } from './pages/admin/NotesModeration';
import { ActivityLog } from './pages/admin/ActivityLog';
import { RoomMappingWorkflow } from './pages/admin/RoomMappingWorkflow';
import { SetupAccount } from './pages/admin/SetupAccount';
import { Register } from './pages/admin/Register';

function Home() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui',
      background: '#f5f5f5'
    }}>
      <div style={{
        width: '350px',
        background: '#fff',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <h1 style={{ marginBottom: '24px', fontSize: '24px' }}>ConstMGR</h1>
        <p style={{ marginBottom: '16px', color: '#666' }}>Construction Plan Management System</p>
        <p style={{ marginBottom: '32px', color: '#666', fontSize: '14px' }}>Scan a QR code to view room plans.</p>
        <a href="/admin/login" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}>Admin Login</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/room/:projectId/:roomId" element={<RoomView />} />
          <Route path="/view/:projectId/:roomId/docs/:documentSetId" element={<PDFViewer />} />
          <Route path="/view/:projectId/:roomId/doc/:documentId" element={<PDFViewer />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/register" element={<Register />} />
          <Route path="/admin/setup" element={<SetupAccount />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/projects/:projectId" element={<ProjectDetail />} />
          <Route path="/admin/projects/:projectId/rooms/:roomId" element={<RoomDetail />} />
          <Route path="/admin/projects/:projectId/documents/:documentId/map" element={<RoomMappingWorkflow />} />
          <Route path="/admin/projects/:projectId/qr-codes" element={<BulkQRCodes />} />
          <Route path="/admin/projects/:projectId/tasks" element={<TaskManagement />} />
          <Route path="/admin/projects/:projectId/notes" element={<NotesModeration />} />
          <Route path="/admin/projects/:projectId/activity" element={<ActivityLog />} />
          {/* Human-readable room URL (must be last - catches /:projectSlug/:roomNumber) */}
          <Route path="/:projectSlug/:roomNumber" element={<RoomView />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
